<template>
<div class="tag-container scannedrecord-tag u-inline">
    <div
      v-for="tag in tags"
      v-bind:key="tag.id"
      class="tag tag--info"
    >
      <strong>{{ tag.label }}</strong>
    </div>
  </div>
</template>
<style>
.scannedrecord-tag {
  margin-top: 0.5em;
}
.scannedrecord-tag tag {
  margin-top: 0.2em !important;
  margin-bottom: 0.25em !important;
}
</style>
<script>
export default {
  name: "scanned-record-tags",
  props: ["tags"],
}
</script>
